export {}

try {
  watchPageLifecycle((prev, next, wasDiscarded) => {
    Ya.Rum.logEventString('page_lifecycle', `${prev} >>> ${next}`, {
      additional: {
        prev,
        next,
        wasDiscarded
      }
    })
  })
} catch (error) {
  console.error(error)
}

/** https://developer.chrome.com/docs/web-platform/page-lifecycle-api */
function watchPageLifecycle(
  callback: (prev: string, next: string, wasDiscarded: 'true' | 'false' | 'unknown') => void
) {
  const getState = () => {
    if (document.visibilityState === 'hidden') {
      return 'hidden'
    }

    if (document.hasFocus()) {
      return 'active'
    }

    return 'passive'
  }

  // Stores the initial state using the `getState()` function (defined above).
  let state = getState()

  // Accepts a next state and, if there's been a state change, logs the
  // change to the console. It also updates the `state` value defined above.
  const onStateChange = (nextState: string) => {
    const prevState = state

    if (nextState !== prevState) {
      callback(prevState, nextState, getWasDiscarded())
      state = nextState
    }
  }

  // Options used for all event listeners.
  const opts = {capture: true}

  // These lifecycle events can all use the same listener to observe state
  // changes (they call the `getState()` function to determine the next state).
  const events = ['pageshow', 'focus', 'blur', 'visibilitychange', 'resume']
  events.forEach((type) => {
    window.addEventListener(type, () => onStateChange(getState()), opts)
  })

  // The next two listeners, on the other hand, can determine the next
  // state from the event itself.
  window.addEventListener(
    'freeze',
    () => {
      // In the freeze event, the next state is always frozen.
      onStateChange('frozen')
    },
    opts
  )

  window.addEventListener(
    'pagehide',
    (event) => {
      // If the event's persisted property is `true` the page is about
      // to enter the back/forward cache, which is also in the frozen state.
      // If the event's persisted property is not `true` the page is
      // about to be unloaded.
      onStateChange(event.persisted ? 'frozen' : 'terminated')
    },
    opts
  )
}

function getWasDiscarded() {
  if ('wasDiscarded' in window.document) {
    return String(window.document.wasDiscarded) as 'true' | 'false'
  }

  return 'unknown'
}
